import { fetchApi } from '@/helpers/fetchApi.js'

export default {
  state: {
    posts: [],
    posts_loading: false,
  },
  getters: {
    latest_posts: (state) =>
      Array.from(state.posts)
        .toSorted((a, b) => new Date(b.published_at) - new Date(a.published_at))
        .slice(0, 2),
    posts: (state) => state.posts,
    posts_by_category: (state) => (id) =>
      state.posts.filter((post) => post.category_id.toString() === id.toString()),
  },
  mutations: {
    setPosts(state, posts) {
      state.posts = posts
    },
    setPostsLoading(state, value) {
      state.posts_loading = value
    },
  },
  actions: {
    async fetchPost(_, id) {
      return new Promise((resolve, reject) => {
        fetchApi(`posts/${id}`)
          .then(resolve)
          .catch(() => reject(`Unable to fetch post with id: ${id}.`))
      })
    },
    async emptyPosts({ commit }) {
      commit('setPosts', [])
    },
    async fetchPosts({ state, commit }) {
      if (state.posts_loading) return

      commit('setPostsLoading', true)

      try {
        const posts = await fetchApi('posts')

        commit('setPosts', posts)
      } finally {
        commit('setPostsLoading', false)
      }
    },
    async loadPosts({ state, dispatch }) {
      if (!state.posts.length) {
        await dispatch('fetchPosts')
      }
    },
  },
}
